import axios from "axios";
import { getChatRoot } from "../../../utils/GeneralUtils";
import APIRoutes from "../../APIRoutes";
import { getChatSocket } from "../../socket/useSocket";
import SocketClientEvents from "../../socket/SocketClientEvents";

/**
 * postCreateChatroomAdmin
 *
 * Recreate a chat room that failed to create.
 *
 * @typedof Chatroom
 * @property {ISonicChatroom} room Chat room id and users
 * @property {number} unreadCount Number of unread messages
 *
 * @param {string} auth_token The user's auth token, used for checking re create permissions.
 * @param {string} senderId Sender id of offer or project apply.
 * @param {string} recipientId Recipiend id of offer or project apply.
 * @param {'offer' | 'project'} relationType Type of content related.
 * @param {string} relationId ID of content related.
 * @param {number} sendDate Send date of content related.
 *
 * @returns {Promise<Chatroom[] | null>} An array of chatroom.
 */

export const postCreateChatroomAdmin = async (
  auth_token: string,
  senderId: string,
  recipientId: string,
  relationType: "offer" | "project",
  relationId: string,
  sendDate: number
) => {
  try {
    const res = await axios.post(
      getChatRoot(APIRoutes.chat.create, "admin"),
      {
        sender_id: senderId,
        recipient_id: recipientId,
        relation_type: relationType,
        relation_id: relationId,
        send_date: sendDate,
      },
      {
        headers: {
          "X-Sonic-Auth": auth_token,
        },
      }
    );

    if (res.data.result === false) return null;

    const socket = getChatSocket();
    socket.emit(
      SocketClientEvents.createdRoom,
      [senderId, recipientId],
      res.data.message.id,
      false
    );
    return res.data;
  } catch (e) {
    return null;
  }
};
